import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

declare var $: any;

@Component({
  selector: 'app-fixbar',
  templateUrl: './fixbar.component.html',
  styleUrls: ['./fixbar.component.css'],
})
export class FixbarComponent implements OnInit {
  user: any;
  constructor(private router: Router, private auth: AuthService) { }

  ngOnInit() {
    this.user = this.auth.user;
  }
  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    // $('#sidebar').removeClass('newWidth');
    if (!$('#expandLoanSubmenu').hasClass('breVis')) {
      $('#sidebar').toggleClass('newWidth');
    }
    if (!$('#submenuOfLoanAppl').hasClass('breVis')) {
      $('#sidebar').toggleClass('newWidth');
    }
    // this.resetSidebar();
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 180);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
  }

  resetSidebar() {
    $('#breVisIDExpended').addClass('breVis');
    $('#expandLoanSubmenu').addClass('breVis');
    $('#expandDelSubmenu').addClass('breVis');
    $('#submenuOfLoanAppl').addClass('breVis');
    $('#expandSettingsMenu').addClass('breVis');
    if ($('.breVisID').hasClass('breVisR')) {
      $('.breVisID').removeClass('breVisR');
      $('#bottombar').removeClass('breVisR');
    }
  }

  deposits() {
    $('#breVisIDExpended').toggleClass('breVis');
    $('.breVisID').toggleClass('breVisR');
    $('#bottombar').toggleClass('breVisR');

    $('#addHighlight').addClass('newClassForHeader');
  }
  loans() {
    $('#sidebar').toggleClass('newWidth');
    $('#expandLoanSubmenu').toggleClass('breVis');
    $('.breVisID').toggleClass('breVisR');
    $('#bottombar').toggleClass('breVisR');
    $('#addHighlightloan').addClass('newClassForHeader');
  }
  cma() {
    $('#expandCmaSubmenu').toggleClass('breVis');
    $('.breVisID').toggleClass('breVisR');
    $('#bottombar').toggleClass('breVisR');
    $('#addHighlightCma').addClass('newClassForHeader');
  }
  loanApp() {
    $('#expandLoanSubmenu').toggleClass('breVis');
    // setTimeout(() => {
    $('#submenuOfLoanAppl').toggleClass('breVis');
    $('#addHighlightSubLapp').addClass('newClassForHeader');
    // }, 180);
  }

  settings() {
    $('.breVisID').toggleClass('breVisR');
    $('#bottombar').toggleClass('breVisR');
    $('#expandSettingsMenu').toggleClass('breVis');
    $('#addHighlightSettings').addClass('newClassForHeader');
  }

  logout() {
    this.auth.logout().subscribe(
      () => {
        this.router.navigateByUrl('/login');
      },
      () => {
        console.log('Cant logout :-(');
      }
    );
    // localStorage.clear();
    // this.router.navigateByUrl('/login');
  }
}
